<div class="no-data">{{ 'NO_DATA' | transloco }}</div>
